import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'redux/rootReducer'
/**
 * Direct selector to the bienAVendre state domain
 */

const selectBienAVendreDomain = (state: AppState) => state.bienAVendre

/**
 * Other specific selectors
 */

export const makeSelectLocations = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.locations
)

export const makeSelectTypebien = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.typeBien
)

export const makeSelectSurfaceTerrainMin = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.surfaceTerrainMin
)

export const makeSelectSurfaceTerrainMax = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.surfaceTerrainMax
)

export const makeSelectSurfaceHabitable = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.surfaceHabitable
)

export const makeSelectSurfaceHabitableMin = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.surfaceHabitableMin
)

export const makeSelectSurfaceHabitableMax = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.surfaceHabitableMax
)

export const makeSelectSurfaceAuSolMin = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.surfaceAuSolMin
)

export const makeSelectSurfaceAuSolMax = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.surfaceAuSolMax
)

export const makeSelectPiscine = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.piscine
)

export const makeSelectBatiMitoyen = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.batiMitoyen
)

export const makeSelectEtages = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.etages
)

export const makeSelectShowedCalculator = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.showedCalculator
)

export const makeSelectShowedRayonForm = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.showedRayonForm
)

export const makeSelectCalculViaConfigurateurAvance = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.calculViaConfigurateurAvance
)

export const makeSelectGarage = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.garage
)

export const makeSelectGaragePosition = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.garagePosition
)

export const makeSelectLabelGarage = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.labelGarage
)

export const makeSelectGarageSpace = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.garageSpace
)

export const makeSelectDoNotUseSurfaceHabitable = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.doNotUseSurfaceHabitable
)

export const makeSelectParticularShapeOrGarage = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.particularShapeOrGarage
)

export const makeSelectDisplayMode = createSelector(
  selectBienAVendreDomain,
  (substate) => substate.displayMode
)

/**
 * Default selector
 */

const selectBienAVendre = createSelector(
  selectBienAVendreDomain,
  (substate) => substate
)

export default selectBienAVendre
